import React from 'react';
import { SocialProviderUnitDto } from '../../../../api-service/clients';
import { SingleSelect } from '../../../../components/single-select/single-select';
import { formatSocialProviderUnitByName, renderSocialProviderUnitOptions } from '../../../offer-and-activity/utilities';

interface ServiceProviderUnitSelectProps {
  value: string;
  onChange: (unitId: string) => void;
  serviceProviderUnits: SocialProviderUnitDto[] | undefined;
  label?: string;
}

export function ServiceProviderUnitSelect({ value, onChange, serviceProviderUnits, label = 'Udførerenhed' }: ServiceProviderUnitSelectProps) {
  const options = serviceProviderUnits ?? [];
  const selectedUnit = options.find(unit => unit.id === value);

  return (
    <SingleSelect<SocialProviderUnitDto>
      label={label}
      value={selectedUnit}
      onChange={unit => onChange(unit.id)}
      options={options}
      getOptionLabel={formatSocialProviderUnitByName}
      renderOption={renderSocialProviderUnitOptions}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      disabled={options.length < 2}
      noOptionsText="Ingen tilgængelige enheder"
      variant="standard"
      style={{ minWidth: '350px', width: '100%' }}
    />
  );
}
